module.exports = "https://99designs-start-assets.imgix.net/js/e303ed35088021f72b8a45125966dc14.jpg";